/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import propTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import API from '@aws-amplify/api';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import LoaderButton from '../LoaderButton';
import Feedback from '../Feedback';

import convertDate from '../../../utils/convertDate';

const useStyles = makeStyles((theme) => ({
  cardContent: {
    flex: 1,
  },
  datePicker: {
    marginTop: 0,
    width: '100%',
  },
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    // fontWeight: 600,
  },
  cardActions: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
  card: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

// const today = new Date();

const timeframe = 320 * 24 * 60 * 60;

export default function Wartung({
  serialNumber, active,
}) {
  Wartung.propTypes = {
    serialNumber: propTypes.string.isRequired,
    active: propTypes.bool.isRequired,
  };
  const classes = useStyles();

  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  // const [activated, setActivated] = useState(false);

  const [onlyOneEntry, setOnlyOneEntry] = useState(false);
  const [letzteWartung, setLetzteWartung] = useState(undefined);
  const [notificationDate, setNotificationDate] = useState(null);

  async function handleSubmit() {
    try {
      setLoading(true);
      setError(false);
      setSuccess(false);

      const timestamp = date ? Math.round(date.getTime() / 1000) : undefined;
      await API.post('emilog', 'addWartung', {
        body: {
          serialNumber,
          timestamp: timestamp ?? null,
        },
      });
      setOnlyOneEntry(false);
      setLetzteWartung(timestamp);
      setNotificationDate(undefined);
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setError(true);
      setLoading(false);
      console.log(err);
    }
  }

  useEffect(() => {
    async function fetch() {
      try {
        const res = await API.get('emilog', 'getWartungen', { queryStringParameters: { serialNumber } });
        if (res.length === 1) {
          setOnlyOneEntry(true);
        }
        setLetzteWartung(res[0].Zeit);
        setNotificationDate(res[0].Meldung);
      } catch (err) {
        console.log(err);
      }
    }
    if (active) {
      fetch();
    }
  }, [serialNumber]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>

      <Card className={classes.card}>
        <CardHeader
          title="Wartung"
        />
        <Divider />
        <CardContent className={classes.cardContent}>
          <Grid container spacing={2}>

            <Grid item xs={12}>
              <KeyboardDatePicker
                value={date}
                className={classes.datePicker}
                disabled={!active}
                disableToolbar
                autoOk
                minDate={letzteWartung ? new Date(letzteWartung * 1000) : undefined}
                variant="inline"
                format="dd.MM.yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Neue Wartung"
                onChange={(e) => setDate(e)}
                invalidDateMessage="Kein korrektes Format"
                minDateMessage="Lizenz abgelaufen"
                inputVariant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Letzte Wartung:

                {letzteWartung && (
                  <>
                    {' '}
                    {convertDate(letzteWartung)}
                    {' '}
                    {onlyOneEntry && '(Instandsetzung)'}
                  </>
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Benachrichtigung versendet:

                {notificationDate ? (
                  ` Ja (am ${convertDate(notificationDate)})`
                ) : notificationDate === null ? (
                  ''
                ) : (
                  ` Nein (fällig am ${convertDate(letzteWartung + timeframe)})`
                )}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions className={classes.cardActions}>
          <Feedback error={error} success={success} />
          <LoaderButton isLoading={loading} text="Wartung eintragen" onClick={handleSubmit} disabled={!active || !date} />
        </CardActions>
      </Card>
    </MuiPickersUtilsProvider>
  );
}
